import { render, staticRenderFns } from "./ModalXacNhanDieuTri.vue?vue&type=template&id=1e992602"
import script from "./ModalXacNhanDieuTri.vue?vue&type=script&lang=js"
export * from "./ModalXacNhanDieuTri.vue?vue&type=script&lang=js"
import style0 from "./ModalXacNhanDieuTri.vue?vue&type=style&index=0&id=1e992602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports